var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClipboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Clipboard"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M9.43555 5H7.43555C6.33098 5 5.43555 5.89543 5.43555 7V19C5.43555 20.1046 6.33098 21 7.43555 21H17.4355C18.5401 21 19.4355 20.1046 19.4355 19V7C19.4355 5.89543 18.5401 5 17.4355 5H15.4355M9.43555 5C9.43555 6 10.2175 6.5 10.7175 6.5H13.9675C14.7175 6.5 15.4355 6 15.4355 5M9.43555 5C9.43555 4 10.2175 3.5 10.7175 3.5H13.9675C14.7175 3.5 15.4355 4 15.4355 5",
    stroke: "#9CA3AF",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon_2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5293 11.4231C14.5293 12.5701 13.6059 13.5 12.4668 13.5C11.3277 13.5 10.4043 12.5701 10.4043 11.4231C10.4043 10.276 11.3277 9.34615 12.4668 9.34615C13.6059 9.34615 14.5293 10.276 14.5293 11.4231Z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2168 16.6154C15.2168 15.086 13.9856 13.8461 12.4668 13.8461C10.948 13.8461 9.7168 15.086 9.7168 16.6154V17C9.7168 17.5523 10.1645 18 10.7168 18H14.2168C14.7691 18 15.2168 17.5523 15.2168 17V16.6154Z",
    fill: "#9CA3AF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipboard);
export default __webpack_public_path__ + "static/media/Clipboard.1f6fcf16351eb6e77409509d3ac73ac5.svg";
export { ForwardRef as ReactComponent };